import { DomSanitizer } from '@angular/platform-browser';
import { HelpersService } from './../../services/tools/helpers.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LiquidacionCapturaService } from './../../services/liquidacion-captura.service';
import { ReporteLiquidacionService } from '../../services/reporte-liquidacion.service';
import { ObrasService} from "../../services/obras.service";
import { ConfirmModalComponent } from './../tools/modals/confirm-modal/confirm-modal.component';
import { AutenticacionService } from '../../services/autenticacion.service';
import { ErrorModalComponent } from './../tools/modals/error-modal/error-modal.component';


@Component({
  selector: 'app-reporte-liquidacion-tabla-dispersiones',
  templateUrl: './reporte-liquidacion-tabla-dispersiones.component.html',
  styleUrls: ['./reporte-liquidacion-tabla-dispersiones.component.scss']
})
export class ReporteLiquidacionTablaDispersionesComponent implements OnInit {
  @ViewChild(ConfirmModalComponent) confirmModal: ConfirmModalComponent;
  @ViewChild(ErrorModalComponent) errorModal: ErrorModalComponent;


  reporte_selected: any = {};
  protected reporte_selected_imagen: any;
  protected inversionista_selected: any = {};
  array_inversionista_selected: any=[];
  protected reporte_selected_id: any;
  liquidaciones_list: any[];
  protected list_email_cco: string;

  processing: boolean;
  protected sending: boolean;
  saving: boolean; 

  private list_send_email: any[] = [];
  private idLiquidacion:any;
  public printing: boolean = false;

  enviar: boolean = false;

  liquidacion_selected: any = {};
  primera_seleccion: boolean = true;
  liquidacionInformacion:string="";

  obraFilter: any = {};
  cargandoTabla: any = 'starting';
  inversionistas: any = 'starting';
  grupoInversionista: any = 'starting';
  loading:any= true;
  lodingInformacionInversionista:boolean = true;
  validarEmail: any='starting';
  validarNotasIniciales: any='starting';
  validarNotasInicialesLongitud: any='starting';
  validarNotasFinales: any='starting';
  validarNotasFinalesLongitud: any='starting';
  errors: any;
  notasIniciales:any="";
  notasFinales:any="";
  notasInicialesGuardar:any="";
  notasFinalesGuardar:any="";
  sendEmail:any;
  arrayInversionistas:any = [];
  arrayInversionistasGrupos:any = [];
  arrayInversionistasList:any = [];
  cobranza:any = 0;
  emailCCO:any;
  esquemasRetencion:any = [
    {esquemaId: 0, descripcion: 'Empresa S,C.'},
    {esquemaId: 1, descripcion: 'Fideicomiso'}
  ];
  esquemaSeleccionado:any = 1;
  ingreso:any;
  egreso:any;
  resultadoBruto:any;
  resultadoBrutoConFormato:any = "";
  validarInversionistasList:any='starting';
  retornoHistorico:any = {};
  tabla:any[] = [];
  total:any;
  puntoEquilibrio:any = {};
  nombreObra:any;
  fechaObra:any;
  public idReporteLiquidacion:any;
  public contentSocios:any = 'starting';
  public numSocios:any;


  constructor(private reporteLiquidacionService: ReporteLiquidacionService,private obrasService: ObrasService,
    private liquidacionCapturaService: LiquidacionCapturaService,
    private router: Router, private activedRoute: ActivatedRoute,
    private helpersService: HelpersService, private sanitizer: DomSanitizer,
        private authService: AutenticacionService) {
    

  }

  ngOnInit() {
    this.getIdLiquidacion();
    this.getLiquidacionesList();
    //this.startCuentaSelected();
  }

  startCuentaSelected(){
    this.reporte_selected = this.reporteLiquidacionService.getDefaultSchedule();
  }

  startReporteSelected() {
    this.array_inversionista_selected = this.reporteLiquidacionService.getDefaultScheduleInversionistas();
  }

  getIdLiquidacion() {
    this.idLiquidacion = this.activedRoute.snapshot.params.id;
    if (this.idLiquidacion) {
      this.getReporte(this.idLiquidacion);
      this.getLiquidacion(this.idLiquidacion);
      this.getInversionistas(this.idLiquidacion);
    } else {
    }
  }

  getReporte(data) {
    this.cargandoTabla = "";
    this.reporte_selected = {};
    this.loading = true;
    this.reporteLiquidacionService.getReporte(data)
      .subscribe((response) => {
        const content_response = response.json().content;
        this.reporte_selected = content_response.participacion;
        this.reporte_selected.liquidacion_reporte = content_response.participacion.liquidacion_reporte;
        this.idReporteLiquidacion = content_response.participacion.liquidacion_reporte.idLiquidacion_Reporte;
        this.reporte_selected.inversionistas = content_response.participacion.liquidacion_reporte.liquidacion_reporte_inversionistas;
        this.reporte_selected.inversionistas_grupos = content_response.participacion.liquidacion_reporte.liquidacion_reporte_grupos;
        this.cobranza = content_response.participacion.liquidacion_reporte.cobranza || 0;
        this.emailCCO = content_response.participacion.liquidacion_reporte.emailCCO;
        this.notasIniciales = content_response.participacion.liquidacion_reporte.notasIniciales;
        this.notasFinales = content_response.participacion.liquidacion_reporte.notasFinales;
        this.ingreso = content_response.participacion.liquidacion_reporte.ingreso;
        this.egreso = content_response.participacion.liquidacion_reporte.egreso;
        this.resultadoBruto = content_response.participacion.liquidacion_reporte.resultadoBruto;
        this.resultadoBrutoConFormato = content_response.participacion.liquidacion_reporte.resultadoBrutoConFormato;
        this.inversionistas = (this.reporte_selected.inversionistas.length > 0)? false: "no_found";
        this.grupoInversionista = (this.reporte_selected.inversionistas_grupos.length > 0)? false: "no_found";
        if(this.inversionistas == 'no_found' && this.grupoInversionista == 'no_found'){
          this.cargandoTabla = "no_found";
        }
        this.esquemaSeleccionado = this.reporte_selected.liquidacion_reporte.retencionTotal;

        if(content_response.participacion.liquidacion_reporte.enviado == 1)
          this.enviar = false;
        else
          this.enviar = true;
        this.loading = false;
        console.log("reporte_selected: ",this.reporte_selected);
      }, (error) => {
        // resuelve errores 403, 500 y sin conexión.
        this.helpersService.httpGlobalError(error);
      });
  }

  getLiquidacion(data) {
    this.liquidacionCapturaService.getLiquidacionByID(data)
      .subscribe(response => {
        const content_response = response.json().content;
        this.liquidacion_selected = content_response;
        this.nombreObra = this.liquidacion_selected.obras.nombreObra;
        this.fechaObra = this.liquidacion_selected.fechaLiquidacion;
      }, error => {
        const content_error = error.json().content;
        // resuelve errores 403, 500 y sin internet
        this.helpersService.httpGlobalError(error);

        if (error.status == 400 && content_error.id) {
          this.router.navigate(['/'])
        }
      })
  }
  

  changeObraFilter($event) {
    this.obraFilter = $event;
    this.array_inversionista_selected = [];
    this.reporte_selected_imagen = "";
    this.arrayInversionistasList = [];
    this.primera_seleccion = true;
    this.validarNotasFinales = '';
    this.validarNotasIniciales = '';
    this.validarNotasFinalesLongitud = '';
    this.validarNotasInicialesLongitud = '';
    this.validarEmail = '';
    this.cobranza = 0;
    this.getLiquidacion(this.obraFilter.idLiquidacion);
    this.getReporte(this.obraFilter.idLiquidacion);
    this.getInversionistas(this.obraFilter.idLiquidacion);
  }

  

  getLiquidacionesList() {
    this.reporteLiquidacionService.getLiquidacionesList()
      .subscribe((response) => {
        const content_response = response.json().content;
        this.liquidaciones_list = content_response;
        console.log("this.liquidaciones_list:",this.liquidaciones_list);
        this.liquidacionInformacion = this.liquidaciones_list.find( liq => liq.idLiquidacion == this.idLiquidacion).informacion;
        console.log(this.liquidacionInformacion);
      });
  }
  
  

  

  print() {
    this.printing = true;
    setTimeout(() => {
      window.print();
    }, 1200);
    window.onafterprint = window.onbeforeprint= () => {
      this.printing = false;
    };
  }

 
  


  return() {
    this.router.navigate(['/liquidacion-revision']);
  }

  getInversionistas(data){
    this.arrayInversionistas = [];
    this.arrayInversionistasGrupos = [];
    this.arrayInversionistasList = [];
    this.reporteLiquidacionService.getInversionistas(data)
      .subscribe((response) => {
        const content_response = response.json().content;

        if(content_response.liquidacion_reporte_inversionistas.length > 0)
        {
          this.arrayInversionistas = content_response.liquidacion_reporte_inversionistas;
          this.agregarLabel();
          
          const respuesta = response.json();

          this.arrayInversionistasList.push({
              'text': 'Inversionistas',
              'children': this.arrayInversionistas,
              'key': 'idInversionistas',
              'label': 'nombre'
            });
        }
        
        if(content_response.liquidacion_reporte_grupos.length > 0)
        {
          content_response.liquidacion_reporte_grupos.forEach((label)=> 
          {
            this.arrayInversionistasGrupos = label.liquidacion_reporte_grupos_elementos;
            this.agregarLabelGrupo();

            let copy = JSON.parse(JSON.stringify(this.arrayInversionistasGrupos));
            this.arrayInversionistasList.push({
              'text': label.inversionistas_grupos.nombre,
              'children': copy,
              'key': 'idLiquidacion_Reporte_Grupo_Elemento',
              'label': 'nombre'
            });
          });
        }
        
        if(this.arrayInversionistasList.length > 0){
          this.validarInversionistasList = 'haveArray';
          if(this.primera_seleccion)
          {
            this.inversionista_selected = this.arrayInversionistasList[0].children[0];
            this.getReporteInversionista(this.inversionista_selected);
            this.primera_seleccion = false;
          }
        }
        
      },(error) => {
      // resuelve errores 403, 500 y sin conexión.
      this.helpersService.httpGlobalError(error);
    });
  }

  agregarLabel(){
    this.arrayInversionistas.forEach((label)=> {
      label.nombre = label.inversionistas.nombre;
    });
  }

  agregarLabelGrupo(){
    this.arrayInversionistasGrupos.forEach((label)=> {
      label.nombre = label.inversionistas.nombre;
    });
  }

  getSocios(){
    this.numSocios = 0;
    this.reporte_selected.inversionistas.forEach((label)=> {
      if(label.sendEmail == 1){
        this.numSocios =this.numSocios + 1;
      }
    });
    this.reporte_selected.inversionistas_grupos.forEach((label)=> {
      if(label.liquidacion_reporte_grupos_elementos.length > 0){
        label.liquidacion_reporte_grupos_elementos.forEach((sendEmail)=> {
          if(sendEmail.sendEmail == 1){
            this.numSocios =this.numSocios + 1;
          }
        });
      }
    });

    if(this.numSocios!= 0){
      this.contentSocios = 'found';
    }else{
      this.contentSocios = 'no_found';
    }
  }

  

chageGrupo(inv, $event){
  inv.sendEmail = $event;
  inv.liquidacion_reporte_grupos_elementos.forEach((label)=>{
    label.sendEmail = $event;
  });
}





  getReporteInversionista(inv) {
    this.array_inversionista_selected = [];
    this.retornoHistorico = [];
    if(Object.keys(inv).length !== 0){

      console.log("##El problema es el siguiente = ",inv.hasOwnProperty('idLiquidacion_Reporte_Inversionistas'));
      
      if(inv.hasOwnProperty('idLiquidacion_Reporte_Inversionistas')){
        this.reporteLiquidacionService.getReporteInversionista(inv.idLiquidacion_Reporte_Inversionistas)
        .subscribe((response => {
          // agregar la lógica al recibir la info del inv seleccionado
          const content_response = response.json().content;

          this.array_inversionista_selected = content_response;
          this.array_inversionista_selected.obras = content_response.obras;
          this.array_inversionista_selected.liquidacion = content_response.liquidacion;
          this.array_inversionista_selected.resultados = content_response.resultados;
          this.array_inversionista_selected.retornosHistoricos = content_response.retornosHistoricos;
          this.array_inversionista_selected.fondoAhorro = content_response.fondoAhorro;
          this.array_inversionista_selected.ingresos = content_response.ingresos;
          this.array_inversionista_selected.egresos = content_response.egresos;
          this.array_inversionista_selected.totalIngresos = content_response.totalIngresos;
          this.array_inversionista_selected.totalEgresos = content_response.totalEgresos;
          this.array_inversionista_selected.imagenes = content_response.imagenes;
          this.total = content_response.reporteRentabilidad.total;
          this.tabla = content_response.reporteRentabilidad.tabla;
          this.puntoEquilibrio = content_response.puntoEquilibrio;
          //this.array_inversionista_selected.puntoEquilibrio.aportacion = content_response.puntoEquilibrio.aportacion;
          this.retornoHistorico = this.array_inversionista_selected.retornosHistoricos;
          
        }));
      }else{
        this.reporteLiquidacionService.getReporteInversionistaGrupo(inv.idLiquidacion_Reporte_Grupo_Elemento)
        .subscribe((response => {
          // agregar la lógica al recibir la info del inv seleccionado
          const content_response = response.json().content;

          this.array_inversionista_selected = content_response;
          this.array_inversionista_selected.obras = content_response.obras;
          this.array_inversionista_selected.liquidacion = content_response.liquidacion;
          this.array_inversionista_selected.resultados = content_response.resultados;
          this.array_inversionista_selected.retornosHistoricos = content_response.retornosHistoricos;
          this.array_inversionista_selected.fondoAhorro = content_response.fondoAhorro;
          this.array_inversionista_selected.ingresos = content_response.ingresos;
          this.array_inversionista_selected.egresos = content_response.egresos;
          this.array_inversionista_selected.totalIngresos = content_response.totalIngresos;
          this.array_inversionista_selected.totalEgresos = content_response.totalEgresos;
          this.array_inversionista_selected.imagenes = content_response.imagenes;
          this.total = content_response.reporteRentabilidad.total;
          this.tabla = content_response.reporteRentabilidad.tabla;
          this.retornoHistorico = this.array_inversionista_selected.retornosHistoricos;
          this.puntoEquilibrio = content_response.puntoEquilibrio;
          
        }));
      }
    }
  }

  calculateTotalRetention(mode=0,rentaConIva){
    let retencionAcumulada = 0;
    if(!this.reporte_selected.inversionistas){
      return retencionAcumulada;
    }
    this.reporte_selected.inversionistas.forEach((inversionista)=> {
      
        retencionAcumulada = retencionAcumulada + this.calculateRetention(mode,inversionista.retorno,rentaConIva,inversionista.participacion_value/100);
      
    });
    this.reporte_selected.inversionistas_grupos.forEach((label)=> {
      if(label.liquidacion_reporte_grupos_elementos.length > 0){
        label.liquidacion_reporte_grupos_elementos.forEach((inversionista)=> {
          
            retencionAcumulada = retencionAcumulada + this.calculateRetention(mode,inversionista.retorno,rentaConIva,inversionista.participacion_value/100);
          
        });
      }
    });

    return retencionAcumulada;
  }

  calculateRetention(mode=0,amount,rentaConIva,porcentaje){
      return this.reporteLiquidacionService.calculateRetention(mode, amount,rentaConIva,porcentaje);
  }

  getRentaConIva(){
    let acumulado = 0.0;
    if(!this.array_inversionista_selected.ingresos){
      return acumulado;
    }
    this.array_inversionista_selected.ingresos.forEach((ingreso)=> {
      if(ingreso.idConceptos == 818 ){ // solo considerar el ingreso por renta, cuyo ID es el 818
          //El valor del importe necesita convertirse en un number para que se sume correctamente
          acumulado = acumulado + Number(ingreso.importe_value);
      }
    });
    return acumulado;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/reporte-liquidacion-tabla-dispersiones/reporte-liquidacion-tabla-dispersiones.component.ts